<template>
  <v-container>
    <v-row>
      <v-col>
        <v-btn
          v-if="prevUrl"
          small
          :to="prevUrl"
          tile
          elevation="0"
          color="transparent"
          style="color: #000"
          class="pl-0 pr-0 mb-5"
        >
          <v-icon>mdi-arrow-left</v-icon>
          Retour
        </v-btn>

        <ppg-exercise-view v-if="ppgExercise !== null" :ppgExercise="ppgExercise" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import { getPPGExerciseAsync } from '@/api/exerciseApi';

  import PpgExerciseView from '@/components/PpgExerciseView';

  export default {
    name: "exercisePpgView",

    components: {
      PpgExerciseView,
    },

    props: {
      id: {
        type: String,
      },
    },

    data() {
      return {
        prevUrl: null,
        ppgExercise: null,
      };
    },

    beforeRouteEnter(to, from, next) {
      next((vm) => {
        vm.prevUrl = from.fullPath;
      });
    },

    async mounted() {
      this.ppgExercise = await getPPGExerciseAsync(this.id);
    },
  };
</script>